@if (!hideIcon()) {
  <iris-icon
    class="pill-icon"
    [name]="icon()"
    [size]="iconSmallSize"
    [usage]="iconDecorativeUsage"
    [colorToken]="iconColorToken()"
  />
}
<span
  class="pill-text"
  [attr.data-test]="'pill-' + displayText()"
>
  {{ displayText() }}
</span>
